import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  lt: {
    translation: {
      // Auth / Login
      "auth.logout": "Atsijungti",
      "auth.termsOfService": "Paslaugų teikimo sąlygos",
      "auth.privacyPolicy": "Privatumo politika",
      "auth.copyright": "\u00a9 {{year}} Averbum. Visos teisės saugomos.",
      "auth.greetingSubtitle": "Prisijunk ir mokykis su virtualiu korepetitoriumi.",
      "auth.consentPrefix": "Prisijungdamas patvirtinu, kad susipažinau su Averbum ",
      "auth.consentPrivacy": "privatumo politika",
      "auth.consentAnd": " ir ",
      "auth.consentTerms": "naudojimosi sąlygomis",
      "auth.consentAge": ", bei patvirtinu, kad man yra daugiau nei 14 metų arba šį veiksmą atlieku su tėvų priežiūra.",
      "auth.signInWithGoogle": "Prisijungti su Google",
      "auth.signInWithFacebook": "Prisijungti su Facebook",
      "auth.notInvitedTitle": "Prisijungti gali tik registruoti naudotojai.",
      "auth.notInvitedQuestion": "Dar neturi paskyros?",
      "auth.notInvitedFriend":
        "Paprašyk kvietimo savo draugo, kuris jau naudojasi Averbum.",
      "auth.notInvitedOr": "arba",
      "auth.notInvitedEmail": "Parašyk mums el. paštu",
      "auth.notInvitedHelp": "— padėsime!",
      "auth.notInvitedClose": "Supratau",
      "auth.authError": "Prisijungimo klaida. Bandykite dar kartą.",

      // Navigation / Menu
      "nav.tasks": "Užduotys",
      "nav.lessons": "Pamokos",
      "nav.mastery": "Meistriškumas",
      "nav.class7": "7 klasė",
      "nav.progress": "Pažanga",
      "nav.history": "Istorija",
      "nav.statistics": "Statistika",
      "nav.problems": "Uždaviniai",

      // Page headers
      "page.curriculum": "7 klasės programa",
      "page.tasks": "Užduotys",
      "page.lessons": "Pamokos",
      "page.mastery": "Meistriškumas",

      // Chat / Composer
      "chat.waitingForSystem": "Laukiama sistemos...",
      "chat.send": "Siųsti",
      "chat.mathFormulaHint":
        "Naudokite Alt+m (\u2325+m) matematinei formulei įvesti",
      "chat.solveNextProblem": "Spręsti kitą uždavinį",
      "chat.nextProblem": "Kitas uždavinys",
      "chat.morePractice": "Daugiau praktikos",
      "chat.goEasier": "Lengviau",
      "chat.levelUp": "Sunkiau",
      "chat.pointsEarned": "Surinkti taškai:",

      // Assignments
      "assignments.assignedAgo": "Paskirta prieš {{time}}.",
      "assignments.dueDatePassed": "Terminas praėjo prieš {{time}}.",
      "assignments.timeLeft": "Liko {{time}} atlikti.",

      // Statistics widget
      "statistics.unfinished": "Nebaigta",
      "statistics.finished": "Baigta",
      "statistics.problemsTackled": "Spręsti uždaviniai:",

      // Onboarding
      "onboarding.welcome": "Labas, malonu tave matyti Averbum platformoje!",
      "onboarding.welcomeSubtitle":
        "Užpildyk savo profilį, kad galėtume pritaikyti mokymąsi tau.",
      "onboarding.stepAbout": "Apie save",
      "onboarding.stepSchool": "Klasė",
      "onboarding.stepGoals": "Tikslai",
      "onboarding.nameQuestion": "Kuo tu vardu?",
      "onboarding.nameHint":
        "Tavo vardo niekur nerodysime, tik norėtume žinoti, kaip į tave kreiptis",
      "onboarding.namePlaceholder": "Įvesk savo vardą",
      "onboarding.school": "Mokykla",
      "onboarding.schoolPlaceholder": "Įveskite mokyklos pavadinimą",
      "onboarding.grade": "Klasė",
      "onboarding.gradePlaceholder": "Pasirinkite klasę",
      "onboarding.textbook": "Matematikos vadovėlis",
      "onboarding.textbookSubtitle":
        "Pasirink vadovėlį, iš kurio mokaisi matematikos",
      "onboarding.textbookOther": "Kitas",
      "onboarding.goals": "Kokie jūsų tikslai?",
      "onboarding.goalsSubtitle":
        "Pasirink vieną ar kelis tikslus, kad galėtume pritaikyti užduotis",
      "onboarding.goalExam": "Pasirengti egzaminui",
      "onboarding.goalTest": "Pasirengti kontroliniam darbui",
      "onboarding.goalGaps": "Užpildyti žinių spragas",
      "onboarding.goalAhead": "Mokytis į priekį",
      "onboarding.goalHomework": "Pagalba su namų darbais",
      "onboarding.goalOlympiad": "Ruoštis olimpiadai",
      "onboarding.next": "Toliau",
      "onboarding.back": "Atgal",
      "onboarding.finish": "Pradėti mokytis!",
      "onboarding.grade5": "5 klasė",
      "onboarding.grade6": "6 klasė",
      "onboarding.grade7": "7 klasė",
      "onboarding.grade8": "8 klasė",
      "onboarding.grade9": "9 klasė (I gimnazijos)",
      "onboarding.grade10": "10 klasė (II gimnazijos)",
      "onboarding.grade11": "11 klasė (III gimnazijos)",
      "onboarding.grade12": "12 klasė (IV gimnazijos)",

      // Challenge page
      "challenge.title": "Naujas iššūkis",
      "challenge.selectTopic": "Pasirink temą",
      "challenge.selectLevel": "Pasirink gebėjimo lygį",
      "challenge.start": "Pradėti!",
      "challenge.yourProgress": "Tavo pažanga",
      "challenge.notStarted": "Nepradėta",

      // Bloom's taxonomy
      "bloom.remember": "Atsiminti",
      "bloom.understand": "Suprasti",
      "bloom.apply": "Pritaikyti",
      "bloom.analyze": "Analizuoti",
      "bloom.evaluate": "Įvertinti",
      "bloom.create": "Sukurti",

      // Alt texts
      "alt.averbum": "Averbum",
      "alt.canvasDrawing": "Piešinys",
      "alt.logo": "logotipas",

      // Time units (Lithuanian plurals: _one, _few, _other)
      "time.second_one": "{{count}} sekundė",
      "time.second_few": "{{count}} sekundės",
      "time.second_other": "{{count}} sekundžių",
      "time.minute_one": "{{count}} minutė",
      "time.minute_few": "{{count}} minutės",
      "time.minute_other": "{{count}} minučių",
      "time.hour_one": "{{count}} valanda",
      "time.hour_few": "{{count}} valandos",
      "time.hour_other": "{{count}} valandų",
      "time.day_one": "{{count}} diena",
      "time.day_few": "{{count}} dienos",
      "time.day_other": "{{count}} dienų",
      "time.month_one": "{{count}} mėnuo",
      "time.month_few": "{{count}} mėnesiai",
      "time.month_other": "{{count}} mėnesių",
      "time.year_one": "{{count}} metai",
      "time.year_few": "{{count}} metai",
      "time.year_other": "{{count}} metų",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "lt",
  fallbackLng: "lt",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
